import React from 'react'

import Icon from '../data/icon.png';
const Entete = () => {
    return (
        <div className="flex justify-between gap-3">
            <div className="flex flex-col gap-3">
                <h1 className='font-bold'>Rawdat Bright Kids </h1>
                
                <h3 className="text-sm"> bgrightkids-26@gmail.com-22212221-22222026-Marche des Femmes</h3>
            </div>
            <img className="mx-auto h-28 w-auto" src={Icon} alt="Your Company" />
            <div className="flex flex-col text-right gap-3">
                <h1 className='font-bold'>روضة أطفالنــا المشرقــون</h1>
                
                <h3 className="text-sm"> bgrightkids-26@gmail.com-22212221-22222026-Marche des Femmes</h3>
            </div>
        </div>
    )
}

export default Entete